import { usePageContext } from 'application/contexts/PageContext';
import { TravelDeduction, TravelDeductionProps } from 'designsystem/calculators/TravelDeduction';
import { Default as TravelDeductionData } from 'designsystem/calculators/TravelDeduction/TravelDeduction.stories';
import { AdobeEvent, fireAdobeEvent } from 'helpers/adobeEvent';
import { useState } from 'react';

export const TravelDeductionFeature = () => {
	const pageContext = usePageContext();
	const { steps } = TravelDeductionData?.args ?? {};
	const [previousStep, setPreviousStep] = useState(null);
	const handleTracking = (step: number) => {
		if (step === previousStep) return;
		const eventName: AdobeEvent =
			step < previousStep
				? 'back_button_click'
				: step === 1
				? 'form_start'
				: step > 1 && step < steps.length - 1
				? 'form_step'
				: 'form_step_complete';

		fireAdobeEvent(eventName, {
			pageName: pageContext.name,
			formType: 'beregner',
			formName: 'beregn korselsfradrag',
			stepName: steps[step - 1],
			stepNo: step,
		});
		setPreviousStep(step);
	};
	return <TravelDeduction {...(TravelDeductionData.args as TravelDeductionProps)} processDataForStep={handleTracking} />;
};
